import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  className: 'BlackFriday2023GiftLayout',
  width: 1350,
  height: 760,
  x: 50,
  y: 50,
  list: [
    {
      id: '5815dcf4-6016-4be3-934e-bc619c0c4dc0',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '8cfb0171-807f-4e9b-833a-6c4a5de241d9',
      type: 'Armature',
      name: 'gift',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      parent: '5815dcf4-6016-4be3-934e-bc619c0c4dc0',
      data: '',
      animationName: 'appear',
      armatureName: 'black_friday_gift',
      dragonbonesName: 'black_friday_gift_exp',
      playOnStart: false,
      progress: 0,
      playTimes: 1
    },
    {
      id: 'ed743b43-d048-4a3c-935d-ab8f12a98949',
      type: 'Text',
      name: 'text',
      nameSpace: '',
      className: '',
      x: 0,
      y: 170,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'ClickToContinue',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 59,
        fontWeight: 'normal',
        fontFamily: 'FrancoisOne',
        fill: 'white',
        stroke: 'white',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0
      },
      parent: '5815dcf4-6016-4be3-934e-bc619c0c4dc0',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class BlackFriday2023GiftLayout {
  static raw = raw;
  root: PIXI.Container
  gift: dragonBones.PixiArmatureDisplay
  text: PIXI.Text

  constructor() {
    populate(this, raw);
  }
}
